import LOGO_ICON from "Content/images/logo/logo-icon.svg";
import map from "lodash/map";
import React from "react";
import Styled from "./sidebarMenuTabs.styled";
import styles from "./sidebarMenuTabs.module.css";
import ButtonHome from "Areas/Sidebar/ButtonHome/ButtonHome";
import SidebarMenuTab from "./sidebarMenuTab/sidebarMenuTab";
const logoImg = React.createElement("img", { src: LOGO_ICON, draggable: "false", className: styles.logo, alt: "logo" });
export default function SidebarMenuTabs(props) {
    const handleTabClick = (key) => {
        if (key === props.tabKey) {
            props.onExpandedChanged && props.onExpandedChanged(!props.expandedMenu);
        }
        else {
            if (!props.expandedMenu)
                props.onExpandedChanged && props.onExpandedChanged(true);
            props.onChangeTab && props.onChangeTab(key);
        }
    };
    return (React.createElement(Styled.SidebarMenuTabsContainer, { rows: props.rows, className: props.className, bgColorDefault: props.bgColorDefault },
        React.createElement("div", { className: styles.content },
            React.createElement("div", { className: styles["tabs-container"] },
                React.createElement(ButtonHome, { defaultHash: props.defaultHash }),
                React.createElement("div", { className: styles.tabs }, map(props.tabs, item => (React.createElement(SidebarMenuTab, { item: item, activeKey: props.tabKey, handleTabClick: () => {
                        handleTabClick(item.key);
                    }, key: item.key }))))),
            React.createElement(props.defaultHash ? "a" : "div", {
                href: props.defaultHash,
                className: styles.logo
            }, logoImg))));
}
SidebarMenuTabs.defaultProps = {
    bgColorDefault: "navbar-bg",
    bgColorActive: "navbar-bg-lighter",
    rotateTab: true
};
